import React from 'react';

const VesselReconstructionIcon = () => <div style={{ fontSize: '12px' }}>3D</div>;

export default VesselReconstructionIcon;
